export default __webpack_public_path__ + "static/media/cart-img.674afccb.jpg";